import {getCaptcha} from '@/api/public'

const state = {
    appName: '当家装修',
    systemInfo: {},
    cityCode: '430100',
    baseImgUrl: 'https://static-cdn.fengjiangit.com/mini-program-imgs/',
    baseUrl: 'http://192.168.1.73:8686/#/',
    appVerCode:'60021000',
    appVerName:'6.21.0',
    verifyLogin: '',
    verifyImg: '',
}

const mutations = {
    SET_SYSTEM_INFO: (state, systemInfo) => {
        state.systemInfo = systemInfo
    },
    SET_PAGE_DATA: (state, pageData) => {
        state.pageData = pageData
    },
    SET_BASE_URL: (state, baseUrl) => {
        state.baseUrl = baseUrl
    },
    SET_VERIFY_LOGIN: (state, verifyLogin) => {
        state.verifyLogin = verifyLogin
    },
    SET_VERIFY_IMG: (state, img) => {
        state.verifyImg = img
    },
}

const actions = {
    // 图形验证
    getVerifyImg({ commit, state }, msg) {
        return new Promise(resolve => {
            if (msg) {
                commit('SET_VERIFY_LOGIN', msg)
            }
            // 获取验证图片
            getCaptcha({}).then(res => {
                console.log(res)
                commit('SET_VERIFY_IMG', res.data.value || '')
                resolve()
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
